import { useTranslation } from 'react-i18next';

export default function StudioSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-10">
          {String(t('facilities.studio.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('facilities.studio.title')}
          </h2>
          {String(t('facilities.studio.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        {String(t('facilities.studio.p1')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-[2.2] mb-5">{__s}</p>))}
        {String(t('facilities.studio.p2')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-[2.2]">{__s}</p>))}

        {String(t('facilities.studio.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-400 tracking-[0.05em] mt-6 italic">{__s}</p>))}
      </div>
    </section>
  );
}
